/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 12:45 PM
 *
 */

import React from 'react';
import { useAppSelector } from 'stores';

import Header from 'components/layout/Header';
import ToggleButton from 'components/layout/Sidebar/ToggleButton';

import Sidebar from '../Sidebar';

const Wrapper = ({ children }: { children: React.ReactNode }) => {
  const open = useAppSelector((state) => state.sidebar.open);

  return (
    <div className="relative">
      {process.env.NEXT_PUBLIC_ENVIRONMENT === 'development' ? (
        <div className="bg-triangle fixed z-50 h-32 w-32 bg-black text-4xl font-medium text-white sm:h-24 sm:w-24 sm:text-3xl">
          <span className="absolute top-[1.3rem] left-2 -rotate-45 sm:top-3.5 sm:left-1">DEV</span>
        </div>
      ) : null}

      <ToggleButton />
      <Sidebar />

      <div
        className={`${
          open
            ? 'relative w-full pl-[23rem] md:ml-0 md:w-full sm:pl-0'
            : 'relative w-full pl-24 sm:pl-0'
        } h-full transition-all duration-200 print:pl-0`}
      >
        <Header />
        <div className="h-screen pt-36 print:pt-0 3xl:flex 3xl:items-center 3xl:justify-center">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Wrapper;
